// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"6ef2c4be","192":"15b50922","250":"56c3152a","463":"c319020a","467":"dded4fbe","488":"74a847aa","674":"f12df16d","722":"5d12293a","753":"d9223969","794":"c8f833bc","796":"61b9ca22","896":"de240904","963":"9b7b0d93","981":"666dba58"}[chunkId] + ".chunk.js";
};